const changeRoute = (path = '/', query = {}) => {};

const pushRoute = route => {};

const pushByNameAndParams = (name = 'app', params = {}) => {};
const pushQuery = query => {};

const getCurrentRoute = () => ({
  name: '',
  params: {
    projectId: window.sharedData.projectId,
    multiviewID: window.sharedData.multiviewId,
    mode: null,
  },
});

const isGanttRoute = () => false;

const isGanttGridRoute = () => false;

const isMultiProjectsRoute = () => false;

const isBoardRoute = () => false;

const isSingleProjectRoute = () => false;

const isColumnsSettingsRoute = () => false;

const isProfileSettings = () => false;

const isTaskSettingsRoute = (routeToCheck = null) => false;

const isListViewRoute = () => false;

const isCommonRoute = () => !isSingleProjectRoute() && !isMultiProjectsRoute();

const isProjectList = () => false;

const isMultiviewList = () => false;

const isTeamRoyte = () => false;

const isWorkloadViewRoute = () => false;

const isCommonWorkloadViewRoute = () => false;

const isTrialCompleteViewRoute = () => false;

const isNoProjectViewRoute = () => false;

const isExportRoute = () => false;

const isHistoryRoute = () => false;

const backRoute = () => {};

const analyticsFromRoute = () => {};

const analyticsRoute = () => {};

export default {
  analyticsRoute,
  analyticsFromRoute,
  isGanttGridRoute,
  changeRoute,
  pushRoute,
  pushQuery,
  getCurrentRoute,
  pushByNameAndParams,
  isGanttRoute,
  isBoardRoute,
  isSingleProjectRoute,
  isColumnsSettingsRoute,
  isTaskSettingsRoute,
  isMultiProjectsRoute,
  isListViewRoute,
  isWorkloadViewRoute,
  isExportRoute,
  isCommonWorkloadViewRoute,
  isTrialCompleteViewRoute,
  isNoProjectViewRoute,
  backRoute,
  isTeamRoyte,
  isMultiviewList,
  isProjectList,
  isProfileSettings,
  isCommonRoute,
  isHistoryRoute,
};
